var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:_vm.free},[_vm._v(_vm._s(_vm.$t('read_for_free')))])}
var staticRenderFns = []

export { render, staticRenderFns }